import React from 'react';

interface IStatisticsIconParams {
  icon: 'calendar' | 'checkmark' | 'clock' | 'dumbell';
}

export const StatisticsIcon: React.FC<IStatisticsIconParams> = ({ icon }: IStatisticsIconParams) => {
  switch (icon) {
    case 'calendar':
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M19 4H17V3C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2C15.7348 2 15.4804 2.10536 15.2929 2.29289C15.1054 2.48043 15 2.73478 15 3V4H9V3C9 2.73478 8.89464 2.48043 8.70711 2.29289C8.51957 2.10536 8.26522 2 8 2C7.73478 2 7.48043 2.10536 7.29289 2.29289C7.10536 2.48043 7 2.73478 7 3V4H5C4.20435 4 3.44129 4.31607 2.87868 4.87868C2.31607 5.44129 2 6.20435 2 7V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V7C22 6.20435 21.6839 5.44129 21.1213 4.87868C20.5587 4.31607 19.7956 4 19 4ZM20 19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V12H20V19ZM20 10H4V7C4 6.73478 4.10536 6.48043 4.29289 6.29289C4.48043 6.10536 4.73478 6 5 6H7V7C7 7.26522 7.10536 7.51957 7.29289 7.70711C7.48043 7.89464 7.73478 8 8 8C8.26522 8 8.51957 7.89464 8.70711 7.70711C8.89464 7.51957 9 7.26522 9 7V6H15V7C15 7.26522 15.1054 7.51957 15.2929 7.70711C15.4804 7.89464 15.7348 8 16 8C16.2652 8 16.5196 7.89464 16.7071 7.70711C16.8946 7.51957 17 7.26522 17 7V6H19C19.2652 6 19.5196 6.10536 19.7071 6.29289C19.8946 6.48043 20 6.73478 20 7V10Z"
            fill="#15364E"
          />
        </svg>
      );
    case 'checkmark':
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.99906 20.4209L2.78906 14.2109L5.61906 11.3809L8.99906 14.7709L18.8791 4.88086L21.7091 7.71086L8.99906 20.4209Z"
            fill="#15364E"
          />
        </svg>
      );

    case 'clock':
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM13 12V7H11V14H17V12H13Z"
            fill="#15364E"
          />
        </svg>
      );

    case 'dumbell':
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3.6 2.375C3.6 1.71816 4.13625 1.1875 4.8 1.1875H6C6.66375 1.1875 7.2 1.71816 7.2 2.375V16.625C7.2 17.2818 6.66375 17.8125 6 17.8125H4.8C4.13625 17.8125 3.6 17.2818 3.6 16.625V14.25H2.4C1.73625 14.25 1.2 13.7193 1.2 13.0625V10.6875C0.53625 10.6875 0 10.1568 0 9.5C0 8.84316 0.53625 8.3125 1.2 8.3125V5.9375C1.2 5.28066 1.73625 4.75 2.4 4.75H3.6V2.375ZM20.4 2.375V4.75H21.6C22.2638 4.75 22.8 5.28066 22.8 5.9375V8.3125C23.4638 8.3125 24 8.84316 24 9.5C24 10.1568 23.4638 10.6875 22.8 10.6875V13.0625C22.8 13.7193 22.2638 14.25 21.6 14.25H20.4V16.625C20.4 17.2818 19.8638 17.8125 19.2 17.8125H18C17.3363 17.8125 16.8 17.2818 16.8 16.625V2.375C16.8 1.71816 17.3363 1.1875 18 1.1875H19.2C19.8638 1.1875 20.4 1.71816 20.4 2.375ZM15.6 8.3125V10.6875H8.4V8.3125H15.6Z"
            fill="#15364E"
          />
        </svg>
      );

    default:
      return null;
  }
};

export default StatisticsIcon;
